module.exports = __webpack_public_path__ + "img/Infografis_ID_06.b471c302.jpg";